import {Injector} from "@angular/core"
import {IsUnique} from "@cm/utils/filter"
import {fetchThrowingErrors} from "@common/helpers/api/fetch"
import {BatchApiCall} from "@common/helpers/batch-api-call/batch-api-call"
import {ApiRequest} from "@common/models/api-request/api-request"
import {
    ConfiguratorResolveDataObjectsLegacyGQL,
    ConfiguratorResolvedDataObjectFragment,
} from "@app/material-editor/services/configurator-data-object-batch-api-call.generated"

type RequestPayload = {
    legacyId: number
}

type ResponsePayload = ConfiguratorResolvedDataObjectFragment

type BatchedRequestPayload = {
    requests: ApiRequest<RequestPayload, ResponsePayload>[]
}

export class ConfiguratorDataObjectLegacyBatchApiCall extends BatchApiCall<RequestPayload, ResponsePayload, BatchedRequestPayload> {
    constructor(private injector: Injector) {
        super(1)
    }

    protected dispatchResponses(batchedPayload: BatchedRequestPayload, responses: ResponsePayload[]) {
        const requestsById = new Map<number, ApiRequest<RequestPayload, ResponsePayload>[]>()
        batchedPayload.requests.forEach((request) => {
            if (!requestsById.has(request.payload.legacyId)) {
                requestsById.set(request.payload.legacyId, [])
            }
            requestsById.get(request.payload.legacyId)!.push(request)
        })
        responses.forEach((response) => {
            const requests = requestsById.get(response.legacyId)
            if (!requests) {
                throw new Error("No request not found")
            }
            requests.forEach((request) => request.resolve(response))
            requestsById.delete(response.legacyId)
        })
        requestsById.forEach((requests) => requests.forEach((request) => request.reject("No response received")))
    }

    protected batchRequests(requests: ApiRequest<RequestPayload, ResponsePayload>[]): BatchedRequestPayload[] {
        return [{requests}]
    }

    protected async callApi(payload: BatchedRequestPayload): Promise<(ResponsePayload | undefined | null)[]> {
        const legacyIds = payload.requests.map((request) => request.payload.legacyId).filter(IsUnique)
        const configuratorResolveDataObjectsLegacyGQL = this.injector.get(ConfiguratorResolveDataObjectsLegacyGQL)
        return fetchThrowingErrors(configuratorResolveDataObjectsLegacyGQL)({
            legacyIds,
        }).then((response) => response.configuratorDataObjects)
    }
}
